import { create } from 'zustand';
import { Cluster } from '@solante/shared';

interface ClusterState {
  cluster: Cluster;
  setCluster: (cluster: Cluster) => void;
}

const isLocalhost = () =>
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const getInitialCluster = (): Cluster => {
  if (typeof window === 'undefined') return 'mainnet-beta';
  const stored = localStorage.getItem('solante:cluster') as Cluster | null;
  if (stored) return stored;
  return isLocalhost() ? 'devnet' : 'mainnet-beta';
};

export const useClusterStore = create<ClusterState>((set) => ({
  cluster: getInitialCluster(),
  setCluster: (cluster) => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('solante:cluster', cluster);
    }
    set({ cluster });
  },
}));
